import React, {FC, useState} from "react"
import {useContentCards, useContentCardActions} from "@irati/braze"
import authentication from "@irati/auth"
import DesktopMenu from "./DesktopMenu"
import NotificationBell from "../shared/Notifications/NotificationBell"
import ContentCardsContainer from "../shared/Notifications/ContentCardsContainer"

const DesktopNotificationMenu: FC = () => {
  const [isMenuDisplayed, setIsMenuDisplayed] = useState(false)
  const {notifications, notificationsCount} = useContentCards()
  const {markContentCardsImpression, markCardsAsActioned} = useContentCardActions()

  const toggle = () => {
    setIsMenuDisplayed((current) => !current)
    const ids = notifications.map((n) => n.id!)
    markContentCardsImpression(ids)
    if (!isMenuDisplayed) {
      markCardsAsActioned(ids)
    }
  }

  if (authentication.isUserGhost()) return null

  return (
    <DesktopMenu
      show={isMenuDisplayed}
      tooltip="Notification Center"
      onOutsideClick={toggle}
      onClick={toggle}
      content={<ContentCardsContainer cards={notifications} />}>
      <NotificationBell isDisplayed={isMenuDisplayed} count={notificationsCount} />
    </DesktopMenu>
  )
}

export default DesktopNotificationMenu
